/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcErrorRhombusRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M12 6.025c-.678 0-1.216.571-1.176 1.248l.293 4.92a.884.884 0 0 0 1.766 0l.293-4.92A1.18 1.18 0 0 0 12 6.025m0 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
      <path
        fillRule="evenodd"
        d="M14.05 1.464a2.9 2.9 0 0 0-4.1 0L1.463 9.95a2.9 2.9 0 0 0 0 4.102l8.485 8.485a2.9 2.9 0 0 0 4.102 0l8.485-8.485a2.9 2.9 0 0 0 0-4.102zm-2.828 1.273a1.1 1.1 0 0 1 1.556 0l8.485 8.485a1.1 1.1 0 0 1 0 1.556l-8.485 8.485a1.1 1.1 0 0 1-1.556 0l-8.485-8.485a1.1 1.1 0 0 1 0-1.556z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcErrorRhombusRegular;
